import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import type { IProduct } from "../types/products";

interface IProductGrid {
  productPage?: boolean;
  products: IProduct[];
  showId?: boolean;
  translateSlug?: boolean;
}

export const Products: React.FC<IProductGrid> = ({
  products,
  showId = false,
  productPage = false,
  translateSlug = false,
}) => {
  const router = useRouter();
  const { locale } = router;

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {(products ?? []).map((product) => {
        const slug =
          locale !== "en" && translateSlug
            ? product?.helpers?.slug
            : product?.slug;

        const featuredImage =
          product.featuredImage?.node.sourceUrl ??
          product.pl?.featuredImage?.node.sourceUrl ??
          "/img/product-empty.jpg";

        const productPath = productPage
          ? `${router.asPath.slice(
              0,
              router.asPath.lastIndexOf("/")
            )}/${slug}-${product.databaseId}`
          : `${router.asPath}/${slug}${showId ? `-${product.databaseId}` : ""}`;

        const width =
          product.featuredImage?.node.mediaDetails.width ??
          product.pl?.featuredImage?.node.mediaDetails.width ??
          459;

        const height =
          product.featuredImage?.node.mediaDetails.width ??
          product.pl?.featuredImage?.node.mediaDetails.width ??
          320;

        return (
          <div key={product.id}>
            <Link href={productPath} passHref prefetch={false}>
              <div
                className={`relative overflow-hidden ${
                  product.featuredImage?.node.sourceUrl ||
                  product.pl?.featuredImage?.node.sourceUrl
                    ? ""
                    : "transform grayscale transition duration-500 ease-in-out hover:grayscale-0"
                }`}
              >
                <Image
                  alt={product?.title}
                  className="mx-auto min-h-full transform transition duration-300 ease-in-out hover:scale-110 hover:cursor-pointer hover:opacity-95"
                  height={height}
                  src={featuredImage}
                  width={width}
                />
              </div>
            </Link>
            <div className="bg-gradient-to-r from-red to-orange p-1 font-bold text-white text-xl">
              <Link href={productPath} passHref prefetch={false}>
                {product?.title}
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};
